:host {
  display: contents;
}

:host(.rtl-direction) > .drag-info {
  --rtl-offset: -100%;
}

.drag-info {
  --rtl-offset: 16px;
  position: fixed;
  left: 0;
  top: 0;
  transform: translate(calc(var(--ch-tree-view-dragging-item-x) + var(--rtl-offset)), calc(var(--ch-tree-view-dragging-item-y) + 8px));
  pointer-events: none;
  z-index: 1;
  animation: fade-in 10ms;
}

.waiting-drop-processing {
  cursor: wait;
}
.waiting-drop-processing ::slotted(*) {
  pointer-events: none;
}

@keyframes fade-in {
  0%, 100% {
    opacity: 0;
  }
}